import React from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, Button, Paper, Typography, Container, CssBaseline } from '@material-ui/core';
import { Link } from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import axios from "axios";
import * as Constants from "utils/constants";
import { fontSize } from "@material-ui/system";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    flex: '1',
  },
  infoBox:{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      "& img": {
          width: '100%',
          border: '1px solid #cccccc'
      },
      "& p": {
          fontSize: '2rem',
          fontWeight: 'bold',
          marginBottom: '20px'
      }
  },
  formControl: {
    minWidth: 80,
    backgroundColor: 'white',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  qtySelect: {
      display:'flex',
      height: '100px',
  },
  paymode: {
      left: '16px',
      "& legend": {
          color: 'white !important'
      },
      "& .MuiRadio-colorPrimary.Mui-checked": {
          color: 'red'
      },
      "& .MuiRadio-colorPrimary": {
          color: 'white'
      },
      "& .MuiFormControlLabel-labelPlacementBottom": {
          margin: '0 10px 0 0'
      }
  },
  paynowBox: {
      display: 'flex',
      justifyContent: 'center'
  },
  paynowbutton: {
      width: '80vw',
      fontSize: '1.5rem'
  }
}));

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


export default function TicketCheckout(props) {
  const classes = useStyles();
  const [qty, setQty] = React.useState('1');
  const [payMode, setPayMode] = React.useState('upi');
  const {register, errors, control, handleSubmit} = useForm({ mode: 'onChange'});
  const [amount, setAmount] = React.useState(0.00);
  const [fessInfo, setfessInfo] = React.useState("");
  const [tickets, setTickets] = React.useState({});
  const [cashfreeData, setCashfreeData] = React.useState("");
  const [razorpayData, setRazorPayData] = React.useState("");
  const [razorpayCBUrl, setRazorpayCBUrl] = React.useState("");
  const [orderId, setOrderId] = React.useState("");
  const [isPayNow, setPayNow] = React.useState(true);
  let query = useQuery(),
  ticketid = query.get("ticket_id");

  var qtyList = [];

  for (var i=0; i<tickets.max_qty_limit; i++) {
      qtyList.push(<MenuItem value={i+1}>{i+1}</MenuItem>);
  }

  const handleChange = (event) => {
    setQty(event.target.value);
    setAmount(event.target.value*tickets.price);
    getFees(event.target.value*tickets.price);
  };

  const handlePaymentChange = (event) => {
    setPayMode(event.target.value);
    getFees(document.getElementsByName("amount")[0].value,event.target.value);
  };

  const submitTopUp = () => {
    document.getElementsByName("pay_button")[0].disabled = true;
    let upiOption = {
        upi : {
        name: "Pay using UPI",
        instruments: [
            {
                method: "upi",
                flows: ["qr", "collect", "intent"],
                apps: ["google_pay", "phonepe"]
            },
        ]
        },
        sequence: ["upi"],
        preferences: {
        show_default_blocks: false // Should Checkout show its default blocks?
        }
    };
    let cardOption = {
        card: {
            name: "Pay Via Cards",
            instruments: [
            {
                method: "card",
                types: document.getElementsByName("paymentMode")[0].value == "cc" ? ["credit"] : ["debit"]
            }
            ]
        },
        sequence: ["card"],
        preferences: {
            show_default_blocks: false // Should Checkout show its default blocks?
        }
    };

      const postTicketData = {
        id : props.currUser.id,
        name : props.currUser.name,
        email : props.currUser.email,
        mobile : props.currUser.mobile,
        ticket_id : tickets.id,
        qty : document.getElementsByName("qty")[0].value,
        amount : document.getElementsByName("amount")[0].value,
        paymentMode : document.getElementsByName("paymentMode")[0].value,
        orderAmount : document.getElementsByName("orderAmount")[0].value,
        feeAmount: document.getElementsByName("feeAmount")[0].value,
        gstAmount: document.getElementsByName("gstAmount")[0].value,
        finalAmount: document.getElementsByName("finalAmount")[0].value
      }


      if(tickets.id == null ||
        props.currUser.id == null ||
        props.currUser.name == null ||
        props.currUser.email == null ||
        props.currUser.mobile == null ||
        document.getElementsByName("qty")[0].value == null) {
        document.getElementsByName("pay_button")[0].disabled = false;
        return;
      }


      axios.post(Constants.API_URL+"/api/book/tickets", postTicketData).then((response) => {
        const mydata = response.data.message;
        document.getElementsByName("pay_button")[0].disabled = false;
        //setCashfreeData(mydata);
        setRazorPayData(mydata);
        setOrderId(mydata.razorpayOrderId);
        setRazorpayCBUrl(mydata.callbackUrl);
        console.log("Response : " + JSON.stringify(mydata));
        let options = {
            "key": "rzp_live_2odtcasOHwM9VH", // Enter the Key ID generated from the Dashboard
            "amount": Math.floor(document.getElementsByName("finalAmount")[0].value * 100),
            "currency": "INR",
            "order_id": mydata.razorpayOrderId,
            "callback_url": mydata.callbackUrl,
            "description": "TapX - Powered by AtomX",
            "image": "https://atomx.s3.ap-south-1.amazonaws.com/X+logo+tilt+Orange.png",
            "prefill":
              {
                  "email": props.currUser.email,
                  "contact": props.currUser.mobile,
              },
            config: {
              display: document.getElementsByName("paymentMode")[0].value == "upi" ? upiOption : cardOption
            },
            "redirect": true,
            "modal": {
              "ondismiss": function () {
                axios.post(Constants.API_URL+"/api/ticket/doTxnFailed", {orderId : mydata.razorpayOrderId});
              }
            }
        };
        console.log(options);
        let rzp1 = new window.Razorpay(options);
        rzp1.open();
      });
      return;
  };

  React.useEffect(() => {
    if(props.currUser != "") {
        axios.get(Constants.API_URL+"/api/tickets/info/" + ticketid).then((response) => {
            console.log(response.data.ticketData);
            if(response.data.ticketData != undefined) {
              setTickets(response.data.ticketData);
              getFees(document.getElementsByName("amount")[0].value);
            }
        });
    }

  }, []);

  const getFees = (totalAmount,payModeSet) => {
    axios.post(Constants.API_URL+"/api/tickets/viewReceipt",
    {
        type:'ticket',
        mode: (payModeSet != undefined) ? payModeSet : payMode,
        amount : totalAmount
    })
    .then((response) => {
        setfessInfo(response.data.feesInfo);
        setPayNow(false);
        return;
    });
  }

  return (
    <React.Fragment>
        <CssBaseline />
        <Container spacing={5} maxWidth="md" component="main">
        {props.currUser != "" ? (
            <React.Fragment>
                <Box pt={4} className={classes.infoBox}>
                    <Typography component="p">
                        {tickets.name}
                    </Typography>
                    <img src={tickets.image} />
                    <Typography component="p">
                        {tickets.price}
                    </Typography>
                </Box>
                <form onSubmit={handleSubmit(submitTopUp)} noValidate>
                    <Box mt={0}>
                        <List dense>
                            <ListItem className={classes.qtySelect}>
                                <ListItemText primary={`Quantity`} />
                                <ListItemSecondaryAction>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="demo-simple-select-helper-label">QTY</InputLabel>
                                        <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={qty}
                                        onChange={handleChange}
                                        label="Quantity"
                                        >
                                            {qtyList}
                                        </Select>
                                    </FormControl>
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem >
                                <ListItemText className={classes.paymode}>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Select Payment Mode</FormLabel>
                                        <RadioGroup row aria-label="paymode" name="paymode"
                                        style={{textAlign: 'center'}}
                                        onChange={handlePaymentChange}
                                        value={payMode}>
                                            <FormControlLabel
                                            value="upi"
                                            control={<Radio color="primary" />}
                                            label={<span>UPI <br/>(Free)</span>}
                                            labelPlacement="bottom"
                                            />
                                            <FormControlLabel
                                            value="cc"
                                            control={<Radio color="primary" />}
                                            label={<span>Credit Card <br/>(+3%)</span>}
                                            labelPlacement="bottom"
                                            />
                                            <FormControlLabel
                                            value="dc"
                                            control={<Radio color="primary" />}
                                            label={<span>Debit Card  <br/>(+1.5%)</span>}
                                            labelPlacement="bottom"
                                            />
                                        </RadioGroup>
                                        </FormControl>
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText primary={`Ticket Amount`} />
                                <ListItemSecondaryAction>
                                    {fessInfo.orderAmount}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText primary={`Convinience Fee`} />
                                <ListItemSecondaryAction>
                                    {fessInfo.feeAmount}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText primary={`GST`} />
                                <ListItemSecondaryAction>
                                    {fessInfo.gstAmount}
                                </ListItemSecondaryAction>
                            </ListItem>

                            <ListItem>
                                <ListItemText primary={`Total Amount`} />
                                <ListItemSecondaryAction>
                                    {fessInfo.finalAmount}
                                </ListItemSecondaryAction>
                            </ListItem>
                        </List>

                    </Box>
                    <Box mt={2} className={classes.paynowBox}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            name="pay_button"
                            disabled={isPayNow}
                            className={classes.paynowbutton}
                        >
                            PAY NOW
                        </Button>
                        <input type="hidden" name="qty" id="qty" value={qty} />
                        <input type="hidden" name="amount" id="amount" value={(amount != 0.00) ? amount : tickets.price} />
                        <input type="hidden" name="paymentMode" id="paymentMode" value={payMode} />
                        <input type="hidden" name="orderAmount" id="orderAmount" value={fessInfo.orderAmount} />
                        <input type="hidden" name="feeAmount" id="feeAmount" value={fessInfo.feeAmount} />
                        <input type="hidden" name="gstAmount" id="gstAmount" value={fessInfo.gstAmount} />
                        <input type="hidden" name="finalAmount" id="finalAmount" value={fessInfo.finalAmount} />
                    </Box>
                </form>
                <form id="redirectForm" method="post" action="https://test.cashfree.com/billpay/checkout/post/submit">
                    <input type="hidden" name="appId" value={cashfreeData.appId ? cashfreeData.appId : ""}/>
                    <input type="hidden" name="orderId" value={cashfreeData.orderId ? cashfreeData.orderId : ""}/>
                    <input type="hidden" name="orderAmount" value={cashfreeData.amount ? cashfreeData.amount : query.get("amount")} />
                    <input type="hidden" name="orderCurrency" value={cashfreeData.currency ? cashfreeData.currency: "INR"}/>
                    <input type="hidden" name="orderNote" value={cashfreeData.orderNote ? cashfreeData.orderNote : ""}/>
                    <input type="hidden" name="customerName" value={cashfreeData.customer_name ? cashfreeData.customer_name : props.currUser.name}/>
                    <input type="hidden" name="customerEmail" value={cashfreeData.customer_email ? cashfreeData.customer_email : props.currUser.email}/>
                    <input type="hidden" name="customerPhone" value={cashfreeData.customer_mobile ? cashfreeData.customer_mobile : props.currUser.mobile}/>
                    <input type="hidden" name="paymentModes" value={cashfreeData.payment_mode ? cashfreeData.payment_mode : ""}/>
                    <input type="hidden" name="returnUrl" value={cashfreeData.returnUrl ? cashfreeData.returnUrl : ""}/>
                    <input type="hidden" name="notifyUrl" value={cashfreeData.notifyUrl ? cashfreeData.notifyUrl : ""}/>
                    <input type="hidden" name="signature" value={cashfreeData.signature ? cashfreeData.signature : ""}/>
                </form>
            </React.Fragment>
        ) : (
            <Box className="login_message">
                You need to <Link to="/signin">LOGIN</Link> to view Buy Tickets
            </Box>
        )}
      </Container>
    </React.Fragment>
  );
}
